<template>
  <div class="select-site" :class="{ 'select-site__active': isCheck }">
    <atom-checkbox
      v-model="isCheck"
      class="select-site__checkbox"
      :title="label"
      :textClass="isCheck ? 'text-site__active' : 'text-site'"
    />
  </div>
</template>

<script>
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"

export default {
  components: { AtomCheckbox },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    isCheck: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.select-site {
  background: #fbfbfc;
  border-radius: 5px;
  border: 1px solid #d8d6de;
  padding: 10px 16px;

  &:hover {
    background: #f7f6fe;
    border: 1px solid #7367f0;
  }
}

.select-site:hover ::v-deep.text-site {
  color: #7367f0;
}

.select-site__active {
  background: #f7f6fe;
  border: 1px solid #7367f0;
}

.select-site ::v-deep {
  .text-site {
    font-weight: 600;
    color: #82868b;
  }
  .text-site__active {
    font-weight: 600;
    color: #7367f0;
  }
}

.select-site__checkbox {
  word-break: break-word;
}
</style>
